import React from "react";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import "./PolicyPages.css";

const sections = [
  {
    num: "01",
    title: "Information We Collect",
    intro: "We may collect the following information:",
    list: [
      "Full name",
      "Contact number",
      "Email address",
      "Shipping address",
      "Payment details (securely processed)",
    ],
  },
  {
    num: "02",
    title: "How We Use Your Information",
    intro: "Your information is used for:",
    list: [
      "Order processing and delivery",
      "Customer support",
      "Sending order updates",
      "Improving user experience",
    ],
  },
  {
    num: "03",
    title: "Data Protection",
    text: "We use secure encryption systems and trusted payment gateways. We do not store credit/debit card details on our servers.",
  },
  {
    num: "04",
    title: "Cookies",
    text: "Our website uses cookies to enhance browsing experience, track website performance, and improve services.",
  },
  {
    num: "05",
    title: "Data Sharing",
    intro: "We do not sell or rent user data. Information may be shared only with:",
    list: [
      "Delivery partners",
      "Payment processors",
      "Legal authorities when required by law",
    ],
  },
  {
    num: "06",
    title: "Your Rights",
    text: "You may request access, modification, or deletion of your personal data by contacting our support team.",
  },
];

const PrivacyPolicy = () => {
  return (
    <>
      <HeaderOne />

      <section className="policy-hero">
        <div className="policy-hero-inner">
          <p className="policy-hero-eyebrow">Kalpana Mart</p>
          <h1>Privacy Policy</h1>
          <p className="policy-hero-sub">
            How we collect, use, and protect your personal information.
          </p>
        </div>
      </section>

      <div className="policy-body">
        <div className="policy-content">
          <div className="policy-meta">
            <span className="policy-badge">
              <span className="policy-badge-dot" />
              Effective immediately
            </span>
          </div>

          <p className="policy-intro">
            Kalpana Mart respects your privacy and is committed to protecting your personal
            data. This policy explains how we collect, use, and safeguard your information.
          </p>

          {sections.map((s) => (
            <div className="policy-section" key={s.num}>
              <div className="policy-section-header">
                <span className="policy-section-num">{s.num}</span>
                <h2>{s.title}</h2>
              </div>
              {s.intro && <p style={{ marginBottom: 10 }}>{s.intro}</p>}
              {s.text && <p>{s.text}</p>}
              {s.list && (
                <ul className="policy-list">
                  {s.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>

      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default PrivacyPolicy;